import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import PaymentForm from "../components/PaymentForm";
import { useAuth } from "../contexts/AuthContext";
import { useTheme } from "../contexts/ThemeContext";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const Subscribe = () => {
  const { plan } = useParams();
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [subscribing, setSubscribing] = useState(false);
  const { darkMode } = useTheme();

  useEffect(() => {
    console.log("Subscribe props:", { plan, isAuthenticated, user, darkMode, subscribing });

    // Vérifier si l'utilisateur est authentifié
    if (!isAuthenticated || !user) {
      console.warn("Utilisateur non authentifié, redirection vers /auth/login");
      toast.error("Veuillez vous connecter pour souscrire à un plan.");
      navigate("/auth/login", { replace: true });
      return;
    }

    // Vérifier si le plan est valide
    if (!["academia", "pro", "entreprise"].includes(plan)) {
      console.warn(`Plan invalide: ${plan}, redirection vers /home-page`);
      toast.error("Plan invalide.");
      navigate("/home-page", { replace: true });
      return;
    }
  }, [isAuthenticated, user, plan, navigate, darkMode, subscribing]);

  const handleClose = () => {
    console.log("handleClose appelé, redirection vers /dashboard");
    navigate("/dashboard", { replace: true });
  };

  return (
    <div
      className={`subscribe-container min-h-screen flex justify-center items-center ${
        darkMode ? "bg-gray-800 text-gray-100" : "bg-gray-50 text-gray-900"
      }`}
    >
      <div
        className={`p-8 rounded-lg shadow-xl w-full max-w-md ${
          darkMode ? "bg-gray-900" : "bg-white"
        }`}
      >
        <h2
          className={`text-3xl font-bold text-center mb-6 ${
            darkMode ? "text-gray-300" : "text-gray-800"
          }`}
        >
          Finaliser votre abonnement {plan}
        </h2>
        {stripePromise ? (
          <Elements stripe={stripePromise}>
            <PaymentForm
              planId={plan}
              onClose={handleClose}
              darkMode={darkMode}
              subscribing={subscribing}
              setSubscribing={setSubscribing}
            />
          </Elements>
        ) : (
          <p className="text-red-500 text-center">
            Erreur : Impossible de charger Stripe.
          </p>
        )}
      </div>
    </div>
  );
};

export default Subscribe;